import './core';

export * from './major_explorer_interface';
export * from './data/services/major_search_service';
export * from './data/services/major_data_toggle_service';
export * from './data/functions/major_tile_fn';
export * from './data/services/survey_step_service';
export * from './data/builders/major_programs_builder';
export * from './data/queries/major_programs_query';
export * from './configuration';

export const major_explorer = 'capability-ng-major-explorer';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/main.ts